import type SearchChargesRequest from "entities/searchChargesRequest";
import type ExemptionsRequest from "../exemptionsRequest";
import type SentEmailMessageSearchRequest from "entities/sentEmailMessageSearchRequest";
import type SearchVehicleRegisterVehiclesRequest from "entities/searchVehicleRegisterVehiclesRequest";
import { observable } from "mobx";

export default class SearchRequest
  implements
    Pick<SearchChargesRequest, keyof SearchChargesRequest>,
    Pick<ExemptionsRequest, keyof ExemptionsRequest>,
    Pick<SentEmailMessageSearchRequest, keyof SentEmailMessageSearchRequest>,
    Pick<SearchVehicleRegisterVehiclesRequest, keyof SearchVehicleRegisterVehiclesRequest>
{
  @observable
  licensePlate?: string;

  @observable
  officialRecordId?: string;

  @observable
  emailAddress?: string;

  @observable
  notificationPhoneNumber?: string;

  @observable
  orderIdent?: number;

  @observable
  bankAccountNumber?: string;

  @observable
  countryId?: string;

  @observable
  bankCode?: string;

  @observable
  chargeId?: string;

  @observable
  chargeOrderId?: string;

  @observable
  cardNumber?: string;

  @observable
  _validSince?: Date;

  @observable
  _validUntil?: Date;
}
